import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormArrayTable,
  title: 'Array Table',
  category: ComponentCategory.FormControls,
};
